/* eslint-disable fp/no-mutation */
/* eslint-disable camelcase */
import { match, Default as _ } from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { getBodyTranslations } from '../../redux/selectors';
import { getStyles } from '../../utils/ej-utils';
import { locales } from '../../utils/locales';
import ErrorHandler from '../reusable/ErrorHandler/ErrorHandler';
import JournalViewError from '../reusable/ErrorHandler/JournalViewError/JournalViewError';

import { NoSaleView, StoredValueTransactionView, UnknownEJViewType } from './JournalViewTypes';
import RetailTransaction from './JournalViewTypes/RetailTransaction';
import './receipt-view.css';
import ReceiptViewActions from './ReceiptViewActions';

function ReceiptView({
    transactionBlob, showNewUi, transactionType, isJournalViewError, isNpos, storeInfo, updateErrorFlag, authToken
}) {
    const {
 RL_Journal, RL_Receipt
} = useSelector(getBodyTranslations);

    const generateEJView = (transaction, footers, type) => match(type)(
        ['NoSale', <NoSaleView footers={footers} storeHeaderInfo={storeInfo.storeHeaderInfo} timezone={storeInfo.storeTimezone} transaction={transaction} />],
        [() => ['RetailTransaction', 'Return'].includes(type), <RetailTransaction footers={footers} locale={locales(storeInfo.storeLocale)} storeHeaderInfo={storeInfo.storeHeaderInfo} timezone={storeInfo.storeTimezone} transaction={transaction} />],
        ['StoredValueTransaction', <StoredValueTransactionView footers={footers} storeHeaderInfo={storeInfo.storeHeaderInfo} timezone={storeInfo.storeTimezone} transaction={transaction} />],
        [_, <UnknownEJViewType type={type} />],
    );

    return (
      <>
        <article
          className="receipt-view"
          id="receipt-view"
          style={getStyles(showNewUi, 'receipt-view')}
        >
          {showNewUi
        ? <p className="ta-sm-l receipt-view-title hide-print">{RL_Receipt}</p>
        : <p className="headline-2 text-color-primary-dark ta-sm-c hide-print">{RL_Journal }</p>}
          {!showNewUi && <p className="hide-print">Transaction UUID : {transactionBlob?.Transaction?.TransactionID}</p>}
          <ErrorHandler key={transactionBlob.Transaction.TransactionID} fallbackUI={<JournalViewError transactionUUID={transactionBlob?.Transaction?.TransactionID} />} setErrorFlag={(isError) => updateErrorFlag(isError)}>
            <article className="border receipt-view-border ta-sm-c" style={{ maxHeight: !showNewUi ? '977px' : '', overflowY: showNewUi ? '' : 'scroll' }}>
              {generateEJView(transactionBlob.Transaction, transactionBlob.footer, transactionType)}
            </article>
          </ErrorHandler>
        </article>
        {!isJournalViewError && (
          <div className={showNewUi ? 'receipt-view-actions-border' : ''}>
            <ReceiptViewActions authToken={authToken} isNpos={isNpos} showNewUi={showNewUi} storeInfo={storeInfo} transactionBlob={transactionBlob} />
          </div>
        )}
      </>
    );
}

ReceiptView.defaultProps = {
    transactionBlob: {}
};

ReceiptView.propTypes = {
    authToken: PropTypes.string.isRequired,
    isJournalViewError: PropTypes.bool.isRequired,
    isNpos: PropTypes.bool.isRequired,
    showNewUi: PropTypes.bool.isRequired,
    storeInfo: PropTypes.shape().isRequired,
    transactionBlob: PropTypes.shape(),
    transactionType: PropTypes.string.isRequired,
    updateErrorFlag: PropTypes.func.isRequired
};

export default ReceiptView;
